import React , {Component} from 'react';
import {checkPermission} from "../../utils/methods";
import {LandingFooterPanelV2, Layout, NavigationBarV2, RecognitionPage} from "../../components";
import PropTypes from "prop-types";
class Platform extends Component{
  render() {
    const { history } = this.props;
    const authToken = (checkPermission() && localStorage && localStorage.getItem('AUTH_TOKEN')) ? true : false;
    return (
      <Layout>
        <NavigationBarV2
          history={history}
          showInternalLinks={false}
          isUser={authToken}
        />
        <RecognitionPage  history={history}/>
        <LandingFooterPanelV2 isUser={authToken} />
      </Layout>
    );
  }
}

Platform.propTypes = {
  history: PropTypes.object
}
export default Platform;